<template>
  <div class="spl-register">
    <div class="container">
      <div class="logo-account">
        <img class="logo" :src="logo" alt />
        <p>
          已有账号，
          <span class="register" @click="toPage()">马上登录</span>
        </p>
      </div>
      <div class="content">
        <p class="title">供应商--后台管理系统</p>
        <div class="form-container">
          <div class="form">
            <p class="error-message">{{errorMessage}}</p>
            <el-input class="input m20" v-model="form.username" placeholder="请输入公司名称"></el-input>
            <el-input class="input m20" v-model="form.head" placeholder="请输入负责人"></el-input>
            <el-input class="input m20" v-model="form.telephone" placeholder="请输入负责人手机号"></el-input>
            <el-input
              class="input m20"
              v-model="form.password"
              type="password"
              placeholder="请设置您的密码"
            ></el-input>
            <el-input
              class="input m20"
              v-model="form.surePassword"
              type="password"
              placeholder="再次输入密码"
            ></el-input>
            <p class="code">
              <el-input class="input" v-model="form.smscode" placeholder="请输入验证码"></el-input>
              <el-button
                :class="disabled?'send color':'send'"
                @click="sendCode"
                :disabled="disabled"
              >{{btntxt}}</el-button>
            </p>
            <el-button class="register" @click="registerSupplier">立即注册</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSupplierTitleInfo } from "common/js/storage";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      logo: "",
      form: {
        username: "",
        head: "",
        password: "",
        surePassword: "",
        telephone: "",
        smscode: "",
      },
      disabled: false,
      btntxt: "发送验证码",
      time: 0,
      errorMessage: "",
    };
  },
  created() {
    this.basicInformation();
  },
  methods: {
    toPage() {
      this.$router.go(-1);
    },
    //发送验证码
    sendCode() {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.form.telephone === "") {
        this.$message({
          message: "手机号不能为空",
          center: true,
        });
        return;
      }
      if (!reg.test(this.form.telephone)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true,
        });
      } else {
        let telephone = this.form.telephone;
        supplier.getSendCode(telephone).then((res) => {
          if (res.success) {
            this.$message({
              message: "发送成功",
              type: "success",
              center: true,
            });
            this.time = 60;
            this.disabled = true;
            this.timer();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重试";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    registerSupplier() {
      this.errorMessage = "";
      console.log(this.form.username);
      if (this.form.username === "") {
        this.errorMessage = "请输入公司名称";
        return false;
      } else if (this.form.head === "") {
        this.errorMessage = "请输入负责人";
        return false;
      } else if (this.form.telephone === "") {
        this.errorMessage = "请输入手机号";
        return false;
      } else if (this.form.password === "") {
        this.errorMessage = "请输入密码";
        return false;
      } else if (this.form.surePassword === "") {
        this.errorMessage = "请再次输入密码";
        return false;
      } else if (this.form.smscode === "") {
        this.errorMessage = "请输入验证码";
        return false;
      }
      let data = this.form;
      supplier
        .postSupplierRegister(data)
        .then((res) => {
          if (res.success) {
            this.$message.success("注册成功");
            this.toPage();
          } else {
            this.errorMessage = res.message;
          }
        })
        .catch((res) => {
          this.$message.error(res.data);
        });
    },
    // 获取基础信息
    basicInformation() {
      let res = getSupplierTitleInfo();
      this.logo = res.logo;
    },
  },
};
</script>
<style lang='scss' scoped>
.spl-register {
  width: 100vw;
  height: 100vh;
  background: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  .container {
    width: 900px;
    height: 654px;
    .logo-account {
      height: 48px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 12px;
      font-size: 16px;
      color: #666666;
      .logo {
        width: 146px;
      }
      .register {
        cursor: pointer;
        color: #c30d23;
      }
    }
    .content {
      height: 590px;
      background: #fff;
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
      .title {
        height: 70px;
        background: rgba(195, 13, 35, 1);
        font-size: 24px;
        color: rgba(247, 247, 247, 1);
        line-height: 70px;
        text-align: center;
      }
      .form-container {
        height: 524px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .form {
          width: 320px;
          position: relative;
          .error-message {
            position: absolute;
            font-size: 12px;
            top: -20px;
            color: rgba(195, 13, 35, 1);
          }
          .m20 {
            margin-bottom: 20px;
          }
          .code {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .input {
              width: 200px;
            }
            .send {
              width: 100px;
              height: 40px;
              padding: 0;
              color: rgba(247, 247, 247, 1);
              background: rgba(195, 13, 35, 1);
              border-radius: 4px;
              font-size: 16px;
            }
            .send:hover {
              background: #de1f1a;
            }
            .send.color {
              background: #c0c4cc;
            }
            .send.color:hover {
              background: #c0c4cc;
            }
          }
          .register {
            width: 320px;
            height: 42px;
            margin-top: 30px;
            background: rgba(195, 13, 35, 1);
            border-radius: 4px;
            font-size: 16px;
            color: rgba(247, 247, 247, 1);
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.spl-register {
  .el-input {
    .el-input__inner:focus {
      border-color: rgba(195, 13, 35, 1);
    }
  }
}
</style>